import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

// Image Generation Skeleton Component
const ImageGenerationSkeleton = ({ optimalSize = 'auto', darkMode }) => {
  // Calculate dimensions based on optimal size
  const getDimensionsFromSize = (size) => {
    // If size is 'auto', use a reasonable default (square)
    if (size === 'auto') {
      return { width: 300, height: 300 };
    }
    
    const [width, height] = size.split('x').map(Number);
    const aspectRatio = width / height;
    
    // Set max width and calculate height to maintain aspect ratio
    const maxWidth = 400;
    const maxHeight = 300;
    
    let finalWidth, finalHeight;
    
    if (aspectRatio > 1) {
      // Landscape
      finalWidth = Math.min(maxWidth, width * (maxHeight / height));
      finalHeight = finalWidth / aspectRatio;
    } else if (aspectRatio < 1) {
      // Portrait
      finalHeight = Math.min(maxHeight, height * (maxWidth / width));
      finalWidth = finalHeight * aspectRatio;
    } else {
      // Square
      const size = Math.min(maxWidth, maxHeight);
      finalWidth = size;
      finalHeight = size;
    }
    
    return { width: finalWidth, height: finalHeight };
  };

  const { width, height } = getDimensionsFromSize(optimalSize);
  
  return (
    <div className="pb-4">
      {/* Creating image text with mask-based shimmer effect */}
      <div>
        <SkeletonTheme 
          baseColor={darkMode ? "#666666" : "#999999"} 
          highlightColor={darkMode ? "#ffffff" : "#ffffff"}
        >
          <div 
            style={{
              width: '120px',
              height: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              marginTop: '5px',
              marginBottom: '12px'
            }}
          >
            <div
              style={{
                width: '120px',
                height: '16px',
                maskImage: `url("data:image/svg+xml,${encodeURIComponent(`
                  <svg width="120" height="16" viewBox="0 0 120 16" xmlns="http://www.w3.org/2000/svg">
                    <text x="0" y="12" font-family="system-ui, -apple-system, sans-serif" font-size="14" fill="black">Creating image</text>
                  </svg>
                `)}")`,
                WebkitMaskImage: `url("data:image/svg+xml,${encodeURIComponent(`
                  <svg width="120" height="16" viewBox="0 0 120 16" xmlns="http://www.w3.org/2000/svg">
                    <text x="0" y="12" font-family="system-ui, -apple-system, sans-serif" font-size="14" fill="black">Creating image</text>
                  </svg>
                `)}")`,
                maskSize: 'contain',
                WebkitMaskSize: 'contain',
                maskRepeat: 'no-repeat',
                WebkitMaskRepeat: 'no-repeat',
                maskPosition: 'left center',
                WebkitMaskPosition: 'left center'
              }}
            >
              <div style={{ width: '100%', height: '100%' }}>
                                        <Skeleton 
                          width="100%"
                          height="100%"
                          style={{ 
                            borderRadius: 0,
                            display: 'block',
                            margin: 0,
                            padding: 0,
                            lineHeight: '1',
                            verticalAlign: 'top'
                          }}
                        />
              </div>
            </div>
          </div>
        </SkeletonTheme>
      </div>
      
      {/* Image skeleton */}
      <SkeletonTheme baseColor={darkMode ? "#202020" : "#e6e6e6"} highlightColor={darkMode ? "#333" : "#d8d8d8"}>
        <Skeleton 
          width={width}
          height={height}
          style={{ 
            borderRadius: '20px',
            display: 'block'
          }}
        />
      </SkeletonTheme>
    </div>
  );
};

export default ImageGenerationSkeleton; 